import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import HeaderWrapper from './HeaderWrapper';

export const headingsSchema: JSONSchema7 = {
    type: 'array',
    title: 'Add Headings',
    required: ['headingLevel'],
    items: {
        type: 'object',
        properties: {
            headingLevel: {
                type: 'integer',
                title: 'Heading tag',
                enum: [1, 2, 3, 4, 5, 6],
                default: 1,
                description: 'Select heading tag eg 1 will resolve to <h1/>',
            },
            headerText: {
                type: 'string',
                title: 'Header text should go here',
                default: '',
                description: 'Add Heading text',
            },
            markerLabel: {
                type: 'string',
                title: 'Markers Label',
                default: '',
            },
            disableHeadingTabStaticData: {
                type: 'boolean',
                title: 'Disable tabbing through static data for heading',
                description: '',
            },
        },
    },
};

const schema: JSONSchema7 = {
    title: 'Header',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        headings: headingsSchema,
        disableTabStaticData: {
            type: 'boolean',
            title: 'Disable tabbing through static data',
            description: '',
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['headings'],
        Accessibility: ['disableTabStaticData'],
    },
];

export const headingsUISchema = {
    items: {
        headerText: {
            'ui:widget': 'ResourcePicker',
        },
        headingLevel: { 'ui:widget': 'CustomSelect' },
        disableHeadingTabStaticData: { 'ui:widget': 'CustomCheckbox' },
        markerLabel: { 'ui:widget': 'CustomTextInput' },
    },
};

const HeaderWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        headings: headingsUISchema,
        disableTabStaticData: { 'ui:widget': 'CustomCheckbox' },
    },
    templateView: HeaderWrapper,
    id: 'Header',
    group: 'component',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default HeaderWidget;
